(function () {
    'use strict';

    angular
        .module('sod.helper')
        .directive('toggleSwitch', toggleSwitch);

    const template = '<div class="switch" style="margin-bottom: 0px;"><input type="checkbox" class="switch-input" ng-model="active" /><label class="switch-paddle" ng-click="toggleActive()"></label></div>';

    function toggleSwitch() {
        return {
            restrict: 'E',
            require: 'ngModel',
            template: template,
            link: function(scope, elem, attr, ctrl) {
                scope.active = false;

                ctrl.$render = function() {
                    scope.active = ctrl.$viewValue;
                };

                scope.toggleActive = function() {
                    scope.active = !scope.active;
                    ctrl.$setViewValue(scope.active);
                };
            }
        };
    }
})();